var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.75.75h.273c3.26 0 4.892 0 6.024.798.324.228.612.5.855.805.848 1.066.848 2.6.848 5.67v2.545c0 2.963 0 4.445-.469 5.628-.754 1.903-2.348 3.403-4.37 4.113-1.257.441-2.83.441-5.98.441-1.798 0-2.698 0-3.416-.252-1.155-.406-2.066-1.263-2.497-2.35C.75 17.472.75 16.625.75 14.932V10.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.75 10.75a3.333 3.333 0 0 1-3.333 3.333c-.666 0-1.451-.116-2.098.057a1.67 1.67 0 0 0-1.179 1.179c-.173.647-.057 1.432-.057 2.098A3.333 3.333 0 0 1 7.75 20.75M1.75 3.25c.492-.506 1.8-2.5 2.5-2.5m2.5 2.5c-.492-.506-1.8-2.5-2.5-2.5m0 0v8"
  })));
};
export default SvgUploadIcon;